/**
 * Lead submission — production uses same-origin /api/contact (Vercel).
 * Optional REACT_APP_BACKEND_URL for alternate API host during dev.
 */
export function getLeadApiUrl() {
  const base = process.env.REACT_APP_BACKEND_URL;
  if (base) return `${String(base).replace(/\/$/, '')}/api/contact`;
  return '/api/contact';
}

/**
 * @param {Record<string, unknown>} body — must include formType: 'contact' | 'configurator'
 * @returns {Promise<{ ok: boolean, status: number, data: object }>}
 */
export async function submitLead(body) {
  const res = await fetch(getLeadApiUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  return { ok: res.ok, status: res.status, data };
}
